export default "__VITE_ASSET__B6dy1INl__"